var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionRequestsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon=calendar-check-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 8.33317H3M13.8333 1.6665V4.99984M7.16667 1.6665V4.99984M8 13.3332L9.66667 14.9998L13.4167 11.2498M7 18.3332H14C15.4001 18.3332 16.1002 18.3332 16.635 18.0607C17.1054 17.821 17.4878 17.4386 17.7275 16.9681C18 16.4334 18 15.7333 18 14.3332V7.33317C18 5.93304 18 5.23297 17.7275 4.69819C17.4878 4.22779 17.1054 3.84534 16.635 3.60565C16.1002 3.33317 15.4001 3.33317 14 3.33317H7C5.59987 3.33317 4.8998 3.33317 4.36502 3.60565C3.89462 3.84534 3.51217 4.22779 3.27248 4.69819C3 5.23297 3 5.93304 3 7.33317V14.3332C3 15.7333 3 16.4334 3.27248 16.9681C3.51217 17.4386 3.89462 17.821 4.36502 18.0607C4.8998 18.3332 5.59987 18.3332 7 18.3332Z",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionRequestsIcon);
export default __webpack_public_path__ + "static/media/ActionRequestsIcon.17b449b394a838079dd3e5ac79e94d9f.svg";
export { ForwardRef as ReactComponent };